import type { TokenBundle } from "@/domain/model/Auth";
import type { SessionStore } from "@/domain/port/SessionStore";

const KEY = "auth.bundle.v1";

export class LocalStorageSessionStore implements SessionStore {
  get(): TokenBundle | null {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    try {
      return JSON.parse(raw) as TokenBundle;
    } catch {
      return null;
    }
  }

  set(tokenBundle: TokenBundle | null): void {
    if (tokenBundle) localStorage.setItem(KEY, JSON.stringify(tokenBundle));
    else localStorage.removeItem(KEY);
  }
}
